import { isNotNilOrEmpty } from '../../value/isNotNilOrEmpty';
import { get } from "../../object/get";
/**
 * Reduces to an object's key value for sorting
 *
 * @aka sortByKey
 * @category Sorting
 * @param {string | symbol} key - The key or the path to the key in the object to reduce
 * @returns {<T = Record<string, unknown>>(obj: T) => unknown}
 * @example
 * sortReduce('count')({ count: 25 })
 * //=> 25
 * @docgen_example
 * sortReduce('count')({ count: 25 });
 */
export var sortReduce = function (key) { return function (obj) {
    var value = typeof key === 'symbol' ? obj[key] : get(obj, key);
    return isNotNilOrEmpty(value) ? value : null;
}; };
